/* eslint-disable import/prefer-default-export */
import lod_ from "lodash";
import { useDispatch } from "react-redux";
import ThemeActions from "redux-react/actions/themeActions";
import { socket } from "redux-react/middleware/ws";
import { useLanguages } from "./useLanguages";
import { useEffect, useState } from "react";
import { removeMessage, display, updateMessage } from "redux-react/reducers/snackBarReducer";
import { useTranslation } from "react-i18next";

export const useThemeActions = () => {
	const { languages } = useLanguages();
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const [translationAction, setTranslationAction] = useState({
		inProgress: false,
		totalCount: 0,
		currentCount: 0
	});

	/**
	 * Start training all questions from a category
	 * @param {*} code
	 * @param {*} type
	 * @param {*} messageID
	 * @param {*} onSuccess
	 * @param {*} onFailure
	 */
	const startCategoryTraining = (
		codes,
		type,
		messageID,
		onSuccess = () => {},
		onFailure = () => {}
	) => {
		dispatch(
			ThemeActions.startCategoryTraining(
				{
					codes,
					type,
					messageID
				},
				onSuccess,
				onFailure
			)
		);
	};

	/**
	 * Start untraining all questions from a category
	 * @param {*} code
	 * @param {*} type
	 * @param {*} onSuccess
	 * @param {*} onFailure
	 */
	const startCategoryUntraining = (codes, type, onSuccess = () => {}, onFailure = () => {}) => {
		dispatch(ThemeActions.startCategoryUntraining(codes, type, onSuccess, onFailure));
	};

	/**
	 * Translate elements using websocket
	 */
	const translateElements = (codes, type, cb = () => {}) => {
		const languagesCode = lod_.map(languages, "code");

		if (!lod_.isEmpty(languagesCode)) {
			// Display a message to the user
			dispatch(
				display({
					id: "loading_translate_id",
					// id: v4(),
					message: `Traduction en cours...`,
					type: "loading"
				})
			);
		}

		// console.log("translateElements", { codes, type, languagesCode });

		socket.emit("answer_item_translate_many", {
			codes,
			type,
			languages: languagesCode
		});

		setTranslationAction(prev => ({
			...prev,
			callback: cb
		}));
	};

	const translationInit = ({ totalCount }) => {
		setTranslationAction(prev => ({
			...prev,
			inProgress: true,
			totalCount,
			currentCount: 0
		}));
	};

	const translationEnd = () => {
		if (!lod_.isNil(translationAction.callback)) {
			translationAction.callback();
		}
		dispatch(
			removeMessage({
				id: "loading_translate_id"
			})
		);
	};

	/**
	 * Response from WS when generating an answer
	 * @param {success, response, result} Object return of WS
	 */
	const generateAnswerTypeResult = ({ success, message, response, result }) => {
		const beforeCount = translationAction.currentCount;
		const newCount = beforeCount + 1;

		dispatch(
			updateMessage({
				id: "loading_translate_id",
				message: t("ASSETS.THEME.translationInProgressMessage", {
					current: newCount,
					total: translationAction.totalCount
				})
			})
		);

		setTranslationAction(prev => {
			return {
				...prev,
				currentCount: newCount
			};
		});

		if (newCount === translationAction.totalCount) {
			setTimeout(() => {
				translationEnd();
			}, 1000);
		}
	};

	useEffect(() => {
		socket.on("llmModule", generateAnswerTypeResult);
		socket.on("llmModule_init", translationInit);
		socket.on("llmModule_end", translationEnd);

		return () => {
			socket.off("llmModule", generateAnswerTypeResult);
			socket.off("llmModule_init", translationInit);
			socket.off("llmModule_end", translationEnd);
		};
	}, [translationAction]);

	useEffect(() => {
		setTranslationAction(prev => {
			return {
				inProgress: false,
				totalCount: 0,
				currentCount: 0
			};
		});

		return () => {
			translationEnd();
		};
	}, []);

	return {
		// 1 category
		startCategoryTraining,
		startCategoryUntraining,
		// translate
		translateElements
	};
};
